module.exports = __webpack_public_path__ + "return.2014f150ee3b628c9ce148b2a8caa189.svg";